import { defineMessages } from 'react-intl';

export default defineMessages({
    menu: {
        id: 'ml.endorsement.header.Menu',
        defaultMessage: 'Menu',
    },
    signOut: {
        id: 'ml.endorsement.header.Sign Out',
        defaultMessage: 'Sign Out',
    },
    yourProfile: {
        id: 'ml.endorsement.header.YOUR PROFILE',
        defaultMessage: 'YOUR PROFILE',
    },
    logout: {
        id: 'ml.endorsement.header.LOG OUT',
        defaultMessage: 'LOG OUT',
    },
    faq: {
        id: 'ml.endorsement.header.FAQ',
        defaultMessage: 'FAQ',
    },
    yourAccount: {
        id: 'ml.endorsement.header.Your Account',
        defaultMessage: 'Your Account',
    },
    policies: {
        id: 'ml.endorsement.header.Policies',
        defaultMessage: 'Policies',
    },
    payments: {
        id: 'ml.endorsement.header.Payments',
        defaultMessage: 'Payments',
    },
    documents: {
        id: 'ml.endorsement.header.Documents',
        defaultMessage: 'Documents',
    },
    newDocuments: {
        id: 'ml.endorsement.header.NewDocuments',
        defaultMessage: 'Documents ( {documentsCounter} new )',
    },
    claims: {
        id: 'ml.endorsement.header.Claims',
        defaultMessage: 'Claims',
    },
    accountHistory: {
        id: 'ml.endorsement.header.Account History',
        defaultMessage: 'Account History',
    }
});
